import con from '../../../connection';
var path = '/companies';
var companies = function (url) { return function () { return ({
    get: function () { return con.get(url + path, {}); },
}); }; };
export default companies;
